import { ENVIRONMENT } from '@/constants';

export const getAuth0RedirectUri = () => {
  if (ENVIRONMENT.DEV) {
    return window.location.origin;
  }

  return ENVIRONMENT.VITE_APP_HOST;
};
